import styled from 'styled-components'
import { Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div`
  ${Media.Phone`
    height: 100%;
    display: flex;
    flex-direction: column;
  `}
`

export const ColorsContainer = styled.div``
export const TemplatesContainer = styled.div`
  padding: 24px ${Spacing.L};

  ${Media.Tablet`
    padding: 24px ${Spacing.L} 20px;
  `}

  ${Media.Phone`
    padding: 4px 16px 16px;
  `}
`
